/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const GET_OWNER_ORGANIZATION = gql`
  query GetOwnerOrganization($owner: String) {
    getOwnerOrganization(owner: $owner) {
      id
      name
      owner
      createdAt
      updatedAt
      billingStatus
    }
  }
`;
